import { Grid } from '@chakra-ui/react'
import { Transportadora } from './Transportadora'
import { Entrega } from './Entrega'
import { Faturamento } from './Faturamento'
import { Consultor } from './Consultor'
import { Innovation } from './Innovation'

export function CardsInfo({ empresa, consultor, dadosPedido, dadosFaturamento, dadosEntrega, dadosTransportadora, dadosModalEntrega }) {
    return (
        <Grid templateColumns="repeat(12, 1fr)" gap={4} fontSize="14px">
            <Innovation empresa={empresa} />
            <Consultor consultor={consultor} />
            <Faturamento dadosFaturamento={dadosFaturamento} />
            <Entrega dadosEntrega={dadosEntrega} dadosModalEntrega={dadosModalEntrega} dadosPedido={dadosPedido} dadosTransportadora={dadosTransportadora} />
            <Transportadora dadosTransportadora={dadosTransportadora} numeroNota={dadosPedido.numero_nota} />
        </Grid>
    )
}
